package io.github.amanshuraikwar.portfolio

import io.github.amanshuraikwar.portfolio.model.MdNode

/**
 * Note: generated by buildWebsite.kts, do not edit!
 */
class GeneratedWebPageBuildDataStore : WebPageBuildDataStore {

	override fun getPageType(): PageType {
		return PageType.RSS_FEEDS
	}

	override fun getData(): List<MdNode> {
		return listOf()
	}
}
